<template lang="html">
  <div class="lessons-component">
    <v-container>
      <v-progress-linear
            v-if="preloader"
            indeterminate
            color="red"
      ></v-progress-linear>
      <v-card>
        <v-card-title>
          Előadások
        </v-card-title>
      <v-data-table
      v-if="lessons"
      :headers="headers"
      :items="lessons"
      :sort-by="['start_date']"
      :items-per-page="15"
      :mobile-breakpoint='NaN'
      >
      <template v-slot:item="{ item, index }">
        <tr>
          <td>{{index+1}}</td>
          <td>{{item.nkh_subject_name}}</td>
          <td style='min-width: 150px'>{{item.lesson_name}}</td>
          <td style='min-width: 150px'>{{item.start_date}}</td>
          <td style='min-width: 150px'>{{item.end_date}}</td>
          <td style='min-width: 130px'>{{item.place_name}}</td>
          <td style='min-width: 130px'>{{item.teacher_name}}</td>
        </tr>
      </template>
      <template v-slot:footer="{pagination}">
        <v-container>
          <v-btn
            rounded
            color="primary"
            @click="lessons_dialog = true"
          >
          Előadások kezelése
          <v-icon dark>mdi-plus</v-icon>
          </v-btn>
        </v-container>
      </template>
      </v-data-table>
    </v-card>
    </v-container>
    <v-row justify="center">
      <v-dialog v-model="lessons_dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
          <v-toolbar dark color="primary">
          <v-toolbar-title>Előadások választása</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon dark @click="lessons_dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
          <v-card-text>
            <v-container>
              <v-row>
              <v-btn fab text small @click="$refs.course_calendar.prev()">
              <v-icon small>mdi-chevron-left</v-icon>
              </v-btn>
              <v-menu
                v-model="menu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="date_text"
                    label="Hónap választása"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="today" @input="menu = false">
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="today = new Date().toISOString().slice(0,10)">Mai nap</v-btn>
                </v-date-picker>
              </v-menu>
              <v-btn fab text small @click="$refs.course_calendar.next()">
              <v-icon small>mdi-chevron-right</v-icon>
              </v-btn>
              </v-row>
              <v-row>
              <v-col cols="8" md="5">
              <v-select
                v-model="training_place_select"
                :items="training_places"
                item-text="place_name"
                item-value="training_place_id"
                label="Oktatási helyszín"
                outlined
              ></v-select>
              </v-col>
              <v-col cols="2" md="2">
              <v-btn text large @click="training_place_select = null, course_lessons = null">Töröl</v-btn>
              </v-col>
              </v-row>
              <v-row>
                <v-btn v-if="type == 'day' && course_lessons "text large @click="type = 'month'">Hónap nézet</v-btn>
              </v-row>
                <div v-if="!course_lessons">
                  <v-row
                  align="center"
                  justify="center"
                  >
                  A naptár betöltéséhez válasszon egy szűrési feltételt!
                  </v-row>
                  <v-row
                  align="center"
                  justify="center"
                  >
                  ("Oktatási helyszín")
                  </v-row>
                </div>
              <v-sheet v-if="course_lessons" height="600">
              <v-calendar
                ref="course_calendar"
                :type="type"
                v-model="today"
                :events="course_lessons"
                @click:more="viewDay"
                @click:event="editLessons"
                :event-color="getEventColor"
                :weekdays="[1, 2, 3, 4, 5, 6, 0]"
                interval-height="50"
              ></v-calendar>
              </v-sheet>
            </v-container>
          </v-card-text>
        </v-card>
        <v-snackbar v-model="snackbar" bottom>
          {{response_text}}
          <v-btn color="pink" text @click="snackbar = false">
            Bezár
          </v-btn>
        </v-snackbar>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import store from '../store'
import { mapFields } from 'vuex-map-fields'

  export default {
    data () {
      return {
        lessons_dialog: false,
        count: 0,
        headers: [
          { text: ''},
          { text: 'Tantárgy', value: 'nkh_subject_name'},
          { text: 'Órasablon', value: 'lesson_name' },
          { text: 'Kezdés', value: 'start_date' },
          { text: 'Befejezés', value: 'end_date' },
          { text: 'Helyszín', value: 'place_name' },
          { text: 'Oktató neve', value: 'teacher_name' },
        ],
        menu: false,
        today: new Date().toISOString().slice(0,10),
        date_text: '',
        training_place_select: '',
        training_places: [],
        course_lessons: null,
        lesson_ids: [],
        type: 'month',
        response_text: '',
        snackbar: false,
      }
    },
    methods: {
      CourseLessons: async function() {
        this.count = 0
        this.lessons = ''
        this.lesson_ids = null
        store.state.showing.preloader = true
        await this.gettoken()
        this.$http.post('/tanfolyamok/lessons', {
          token: this.token,
          course_id: this.course_id,
        }).then((response) => {
          store.state.showing.preloader = false
          this.lessons = response.data['lessons']
          this.lesson_ids = response.data['lesson_ids']
          
        }, (error) => {
          this.error_text = error.data
        })
      },
      getPlaces: async function() {
        this.training_places = ''
        store.state.showing.preloader = true
        await this.gettoken()
        this.$http.post('/tanfolyamok/training_places', {
          token: this.token,
        }).then((response) => {
          store.state.showing.preloader = false
          this.training_places = response.data
          
        }, (error) => {
          this.error_text = error.data
        })
      },
      dateToDisplay () {
        var options = { year: 'numeric', month: 'long'};
        var datum  = new Date(this.today);
        this.date_text = datum.toLocaleDateString('hu-HU',options);
      },
      viewDay ({ date }) {
        this.today = date
        this.type = 'day'
      },
      prev () {
        this.$refs.course_calendar.prev()
      },
      next () {
        this.$refs.course_calendar.next()
      },
      Lessons: async function() {
        this.course_lessons = null
        store.state.showing.preloader = true
        await this.gettoken()
        this.$http.post('/tanfolyamok/lessons_all', {
          token: this.token,
          training_place: this.training_place_select,
          course_pattern: this.course_pattern,
        }).then((response) => {
          store.state.showing.preloader = false
          this.course_lessons = response.data
          
        }, (error) => {
          this.error_text = error.data
        })
      },
      editLessons: async function({ event }) {
        this.tanrend_upload = false
        store.state.showing.preloader = true
        await this.gettoken()
        this.$http.post('/tanfolyamok/lessons_add', {
          token: this.token,
          course_id: this.course_id,
          lesson_id: event.lesson_id,
        }).then((response) => {
          store.state.showing.preloader = false
          this.snackbar = true
          this.response_text = response.data
          this.CourseLessons()
          this.lessonHeadcount()
          this.tanrend_upload = true
          
        }, (error) => {
          this.error_text = error.data
        })
      },
      lessonHeadcount: async function() {
        this.headcount_update = false
        store.state.showing.preloader = true
        await this.gettoken()
        this.$http.post('/tanfolyamok/lessons_headcount', {
          token: this.token,
          course_id_tl: this.course_id,
        }).then((response) => {
          this.headcount_update = response.data
          store.state.showing.preloader = false
          
        }, (error) => {
          this.error_text = error.data
        })
      },
      getEventColor (event) {
        if (this.lesson_ids != null) {
          if (this.lesson_ids.includes(event.lesson_id)) {
            return '#00cc66'
          } else {
            return '#424242'
          }
        } else {
          return '#424242'
        }
      },
    },
    mounted() {
      //this.CourseLessons()
      this.getPlaces()
      this.dateToDisplay()
      this.Lessons()
    },
    watch: {
      course_id: function (value) {
        this.CourseLessons()
        this.training_place_select = this.place_id
        this.Lessons()
      },
      training_place_select: function (value) {
          this.Lessons()
      },
      today: function (value) {
          this.dateToDisplay()
      },
    },
    computed: {
    ...mapFields([
    'tanfolyamok.course_id',
    'tanfolyamok.course_pattern',
    'tanfolyamok.place_id',
    'tanfolyamok.lessons',
    'tanfolyamok.course_start',
    'showing.preloader',
    'tanfolyamok.tanrend_upload',
    'tanfolyamok.headcount_update',
  ]),
  },
  }
</script>

<style lang="css">
</style>
